// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableSearch td:last-child{width:310px}.tableSearch,.tableSearch td:last-child input,.textButtom{width:100%}.textButtom td:last-child{font-size:85%;white-space:nowrap;width:50px}.headingCall{font-weight:400;margin:0 0 9px;padding:0 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
